import React, { PropsWithChildren, useEffect } from 'react';

import { Property } from 'csstype';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';

const Wrapper = styled.div<{ all?: Property.All }>`
  all: ${({ all = 'inherit' }) => all};
`;

const IsInViewPort = ({
  children,
  onViewVisible,
  cssAll,
}: PropsWithChildren<{
  onViewVisible: () => void;
  cssAll?: Property.All;
}>) => {
  const { ref: campaignsRef, inView: isInView } = useInView({
    triggerOnce: true,
    fallbackInView: true,
  });

  useEffect(() => {
    if (isInView) {
      onViewVisible?.();
    }
  }, [isInView]);

  return (
    <Wrapper all={cssAll} ref={campaignsRef}>
      {children}
    </Wrapper>
  );
};

export default IsInViewPort;
